import { ref } from "vue";

const pwaHomePageUrl = '/';
const debugStep = ref(0);
const showOpenInDefaultTip = ref(false);
export { pwaHomePageUrl,debugStep,showOpenInDefaultTip }